import { useState } from "react";

// 입력 받을 사양 필드 목록 (원하는 대로 추가/수정)
const SPEC_KEYS = ["OS", "CPU", "RAM", "GPU", "저장공간", "DirectX", "기타"];

function GameEditSystemRequirement({ requirements, onChange }) {
  const [showRecommended, setShowRecommended] = useState(false);

  // 최소/권장 사양 변화 시
  const handleSpecChange = (type, key, value) => {
    onChange({
      ...requirements,
      [type]: {
        ...requirements[type],
        [key]: value
      }
    });
  };

  // 사양 입력 테이블
  const renderSpecInputTable = (type, specs) => (
    <table className="w-full text-sm text-left text-gray-300 mt-2">
      <tbody>
        {SPEC_KEYS.map((key) => (
          <tr key={key} className="align-top">
            <td className="py-1 pr-4 text-gray-400 whitespace-nowrap w-28">{key}</td>
            <td className="py-1 whitespace-pre-line">
              <input
                type="text"
                value={specs?.[key] || ""}
                onChange={e => handleSpecChange(type, key, e.target.value)}
                className="w-full bg-neutral-700 text-white px-2 py-1 rounded"
                placeholder={`${key} 입력`}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div className="bg-neutral-800 p-4 rounded">
      <h4 className="text-md font-semibold mb-3">시스템 요구 사항</h4>

      <div>
        <h5 className="text-white text-sm font-semibold border-b border-gray-600 pb-1">최소 사양</h5>
        {renderSpecInputTable("minimum", requirements.minimum || {})}
      </div>

      <div className="mt-4">
        <div className="flex justify-between items-center border-b border-gray-600 pb-1">
          <h5 className="text-white text-sm font-semibold">권장 사양</h5>
          <button
            type="button"
            onClick={() => setShowRecommended(!showRecommended)}
            className="text-gray-400 text-sm hover:text-white transition"
          >
            {showRecommended ? "▲ 닫기" : "▼ 열기"}
          </button>
        </div>
        {showRecommended && renderSpecInputTable("recommended", requirements.recommended || {})}
      </div>
    </div>
  );
}

export default GameEditSystemRequirement;